import React from 'react';
import { ArticleListing } from '../components/articles/ArticleListing';
import { careerArticles } from '../data/articles';

export default function ConseilsCarrierePage() {
  return <ArticleListing articles={careerArticles} section="carriere" />;
}